// src/store/slices/optionSlice.ts
import { StateCreator } from "zustand";
import { Option, OptionSlice } from "../../interfaces";

export const createOptionSlice: StateCreator<OptionSlice> = (set) => ({
  optionsZustand: JSON.parse(localStorage.getItem("options") || "[]"),
  addOptionZustand: (option) =>
    set((state) => {
      const newOptions = [...state.optionsZustand, option];
      localStorage.setItem("options", JSON.stringify(newOptions));
      return { optionsZustand: newOptions };
    }),
  updateOptionZustand: (optionID, newInfo) =>
    set((state) => {
      const newOptions = state.optionsZustand.map((option) =>
        option.optionType === optionID
          ? {
              ...option,
              optionInfo: option.optionInfo.map((info) =>
                info.id === newInfo.id ? newInfo : info
              ),
            }
          : option
      );
      localStorage.setItem("options", JSON.stringify(newOptions));
      return { optionsZustand: newOptions };
    }),
  removeOptionZustand: (optionID) =>
    set((state) => {
      const newOptions = state.optionsZustand.filter(
        (option) => option.optionType !== optionID
      );
      localStorage.setItem("options", JSON.stringify(newOptions));
      return { optionsZustand: newOptions };
    }),
  addPageZustand: (page: any) =>
    set((state) => {
      let newOptions = [...state.optionsZustand];
      const pageOption = newOptions.find(
        (opt) => opt.optionType === "lastPages"
      );

      if (!pageOption) {
        const newPageOption: Option = {
          optionType: "lastPages",
          optionSize: "small",
          optionPosition: 0,
          optionFilter: "default",
          optionInfo: [
            { id: page.path, name: "path", value: page.path },
            { id: `${page.path}_title`, name: "title", value: page.title },
            { id: `${page.path}_icon`, name: "icon", value: page.icon },
          ],
        };
        newOptions.push(newPageOption);
      } else {
        const existingPage = pageOption.optionInfo.find(
          (info) => info.value === page.path
        );
        if (!existingPage) {
          const pageInfo = [
            { id: page.path, name: "path", value: page.path },
            { id: `${page.path}_title`, name: "title", value: page.title },
            { id: `${page.path}_icon`, name: "icon", value: page.icon },
          ];
          pageOption.optionInfo.push(...pageInfo);
          if (pageOption.optionInfo.length > 15) {
            // 5 pages * 3 info per page
            pageOption.optionInfo = pageOption.optionInfo.slice(3);
          }
        }
      }

      localStorage.setItem("options", JSON.stringify(newOptions));
      return { optionsZustand: newOptions };
    }),
});
